module.exports = __webpack_public_path__ + "static/media/tracker-2G.83439ffb.png";